export default "__VITE_ASSET__BfKl96xq__"